import * as React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ListEditorDefaultDeletor(_ref) {
  let {
    data,
    onDismiss,
    onSuccess
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    children: ["Delete", /*#__PURE__*/_jsx("button", {
      onClick: () => onSuccess(),
      children: "confirm"
    }), /*#__PURE__*/_jsx("button", {
      onClick: () => onDismiss(),
      children: "cancel"
    }), /*#__PURE__*/_jsx("code", {
      children: JSON.stringify(data)
    })]
  });
}